import _ from 'lodash'
import { useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useTableColumnVisibility, useTablePagination, useTableSorting } from '../../redux/table/hooks'
import {
  getOrders,
  areOrdersLoading,
  getTransactionFilters,
  getTransactionsPageSize,
  OrdersActions
} from '../../redux/orders'
import { ColumnType, FiltersMetaRowWrapper, Table } from '../../components/Table'
import { OrderData } from '../../redux/order'

import { filterKeysToTranslationsMapper } from './filterKeysToTranslationsMapper'
import { dateFilterKeys } from './dateFilterKeys'

export type TransactionsDataTableProps = {
  tableColumns: ColumnType<OrderData>[]
}

export const TransactionsDataTable = ({ tableColumns }: TransactionsDataTableProps) => {
  const dispatch = useDispatch()
  const orders = useSelector(getOrders)
  const ordersLoading = useSelector(areOrdersLoading)
  const filters = useSelector(getTransactionFilters)
  const pageSize = useSelector(getTransactionsPageSize)

  useEffect(() => {
    dispatch(
      OrdersActions.loadOrders({
        page: 1,
        pageSize
      })
    )
  }, [dispatch, pageSize])

  const tableOptions = {
    ...useTableSorting('transactions'),
    ...useTablePagination('transactions'),
    ...useTableColumnVisibility('transactions')
  }

  const filtersMetaRow = useCallback(
    () => (
      <FiltersMetaRowWrapper
        filters={filters}
        dateFilterKeys={dateFilterKeys}
        filterKeysToTranslationsMapper={filterKeysToTranslationsMapper}
        onClose={filterKey => dispatch(OrdersActions.clearFilter({ filterKey }))}
      />
    ),
    [filters, dispatch]
  )
  const renderMetaRow = _.keys(filters).length > 0 ? filtersMetaRow : undefined

  return (
    <Table<OrderData>
      rowKey="orderId"
      dataSource={orders}
      columns={tableColumns}
      renderMetaRow={renderMetaRow}
      loading={ordersLoading}
      {...tableOptions}
      data-automation-id="transactionTableData"
    />
  )
}
